<template>
  <component :is="element" :class="classes">
    <!-- @slot Slot for subheading content. -->
    <slot />
  </component>
</template>

<script>
export default {
  name: 'PdlSubheading',
  props: {
    /**
     * The subheading level (1-6), which corresponds to the `<h1>` to `<h6>` section heading elements. If no level is defined, a `<p>` tag will be used.
     */
    level: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Size of subheading (`xxl`, `xl`,`lg`, `md`, & `sm`), which determines subheading font size.
     */
    size: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    element() {
      return this.level ? `h${this.level}` : 'p';
    },
    sizeClass() {
      return `pdl-subheading--${this.size}`;
    },
    classes() {
      return {
        'pdl-subheading': true,
        [this.sizeClass]: this.size,
      };
    },
  },
};
</script>

<style lang="scss">
@import 'SectionHeader.scss';
</style>
